import * as tslib_1 from "tslib";
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
var defaultLifeTimeInfo = Object.freeze({
    created: false,
    removed: false,
    retrievedCount: 0,
});
var attachmentModelsTraceInfo = {};
function getOrCreateDefault(attachmentId) {
    var lifeTimeInfo = attachmentModelsTraceInfo[attachmentId];
    if (!lifeTimeInfo) {
        lifeTimeInfo = tslib_1.__assign({}, defaultLifeTimeInfo);
        attachmentModelsTraceInfo[attachmentId] = lifeTimeInfo;
    }
    return lifeTimeInfo;
}
function isFeatureEnabled() {
    return isAttachmentFeatureEnabled('doc-attachment-traceAttachmentModelLifeTime');
}
export function traceAttachmentModelCreated(attachmentId) {
    if (isFeatureEnabled()) {
        attachmentModelsTraceInfo[attachmentId] = tslib_1.__assign({}, defaultLifeTimeInfo, { created: true });
    }
}
export function traceAttachmentModelRemoved(attachmentId) {
    if (isFeatureEnabled()) {
        var lifeTimeInfo = getOrCreateDefault(attachmentId);
        lifeTimeInfo.removed = true;
    }
}
export function traceAttachmentModelRetrieved(attachmentId) {
    if (isFeatureEnabled()) {
        var lifeTimeInfo = getOrCreateDefault(attachmentId);
        lifeTimeInfo.retrievedCount += 1;
    }
}
export function logAttachmentModelLifeTimeInfo(attachmentId) {
    if (isFeatureEnabled()) {
        var lifeTimeInfo = attachmentModelsTraceInfo[attachmentId] || tslib_1.__assign({}, defaultLifeTimeInfo);
        var customData = datapoints.AttachmentModelLifeTimeInfo.datapoint.customData(lifeTimeInfo);
        logUsage(datapoints.AttachmentModelLifeTimeInfo.datapoint.name, customData);
    }
}
//# sourceMappingURL=attachmentModelLifeTimeTracer.js.map